document.addEventListener('DOMContentLoaded', () => {
  const umantisIframe = document.querySelector('#umantis_iframe');
  if (umantisIframe) {
    let ifHeight;
    const src = umantisIframe.getAttribute('src');
    if (src) {
      const iframe = document.createElement('iframe');
      iframe.src = src;
      iframe.name = document.location.href;
      iframe.width = '100%';
      iframe.height = 500;
      iframe.frameBorder = 0;
      iframe.scrolling = 'no';
      document.getElementById('umantis_iframe').appendChild(iframe);
      let h = 0;
      iframe.onload = () => {
        window.addEventListener('message', (e) => {
          if (Math.ceil(iframe.height) !== h) {
            h = Math.ceil(Number(e.data.replace(/[^0-9.]+/g, '')));

            // eslint-disable-next-line no-restricted-globals
            if (!isNaN(h) && h > 0 && h !== ifHeight) {
              /* Height has changed, update the iframe */
              ifHeight = h;
              iframe.height = h;
            }
          }
        });
      };
    }
  }
});
